import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Auto-recover from stale chunk references after a deploy. When a tab loaded
// before a deploy tries to lazy-load a chunk whose hash no longer exists, S3
// 404s and CloudFront serves index.html, which the browser fails to parse as
// JS. Reload once to pick up the new bundle; the sessionStorage guard prevents
// a loop if the error is actually something else.
const RELOAD_GUARD_KEY = 'pw_chunk_reload_attempted';
const isChunkLoadError = (err: unknown): boolean => {
  if (!err) return false;
  const name = (err as { name?: string }).name;
  const message = (err as { message?: string }).message ?? String(err);
  return name === 'ChunkLoadError' || /Loading chunk [^ ]+ failed/i.test(message);
};
const handleChunkError = (err: unknown) => {
  if (!isChunkLoadError(err)) return;
  if (sessionStorage.getItem(RELOAD_GUARD_KEY)) return;
  sessionStorage.setItem(RELOAD_GUARD_KEY, '1');
  window.location.reload();
};
window.addEventListener('error', (e) => handleChunkError(e.error));
window.addEventListener('unhandledrejection', (e) => handleChunkError(e.reason));
window.setTimeout(() => sessionStorage.removeItem(RELOAD_GUARD_KEY), 10000);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();